
  export default {
    name: `ErrorPopup`,
    props: {
      value: {
        type: Boolean,
        default: false
      },
      errors: {
        type: Array,
        default: () => []
      }
    }
  }
